// extracted by mini-css-extract-plugin
module.exports = {"root":"components-ui-icon-root","disabled":"components-ui-icon-disabled"};